export interface ModelOption {
  value: string;
  label: string;
}

/* eslint-disable i18next/no-literal-string -- vendor model and provider names */
export const IMAGE_MODEL_OPTIONS: ModelOption[] = [
  { value: 'gemini-3-pro-image', label: 'Gemini 3 Pro Image' },
  { value: 'gemini-3.1-flash-image', label: 'Gemini 3.1 Flash Image' },
  { value: 'dall-e-3', label: 'DALL-E 3' },
  { value: 'gpt-image-1', label: 'GPT Image 1' },
  { value: 'gpt-image-2', label: 'GPT Image 2' },
  { value: 'firefly-v3', label: 'Firefly V3' },
  { value: 'firefly-v4-standard', label: 'Firefly V4' },
];

export const VIDEO_MODEL_OPTIONS: ModelOption[] = [
  { value: 'veo-3.1', label: 'Veo 3.1' },
  { value: 'runway-gen-4', label: 'Runway Gen-4' },
];
/* eslint-enable i18next/no-literal-string */

export const DEFAULT_IMAGE_MODEL = IMAGE_MODEL_OPTIONS[0].value;
export const DEFAULT_VIDEO_MODEL = VIDEO_MODEL_OPTIONS[0].value;
